
import { Data as MarketContent } from './market/index'
import { Data as AccountContent } from './account/index'
import { Data as IntroduceContent } from './introduce/index'
import { Data as OtherContent } from '../../listenKey/index'

let aaa = JSON.stringify(OtherContent).replaceAll("/market/","/market?")
aaa = aaa.replaceAll("/swap-market","/market")
aaa = aaa.replaceAll("open-api-ws.bingx.com","open-api-cswap-ws.bingx.com")
aaa = aaa.replaceAll("/market?<listenKey>","/market?listenKey=")
aaa = aaa.replaceAll("wss://open-api-cswap-ws.bingx.com/market?listenKey=","wss://open-api-cswap-ws.bingx.com/market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")
const Other = {
    "path": "listenKey.html",
    "name": "Listen Key",
    "content": JSON.parse(aaa)
  }
const Market = {
    "path": "market.html",
    "name": "Websocket Market Data",
    "content": MarketContent
}

const introduce = {
    "path": "",
    "name": "Introduction",
    "content": IntroduceContent
}
const Account = {
    "path": "account.html",
    "name": "Account Endpoints",
    "content": AccountContent
  }

const list_temp = [
    introduce,
    Other,
    Market,
    Account,
]
export const List = list_temp



// WEBPACK FOOTER //
// ./src/config/en-US/cswap/websocket/index.js